import React from 'react'
import styles from './LbUsps.module.css'
import { FaBolt, FaShieldAlt, FaChartLine, FaPuzzlePiece, FaCode } from 'react-icons/fa'
import { motion } from 'framer-motion'

const LbUsps = () => {
    const usps = [
        {
            icon: <FaBolt />,
            title: 'Instant Capture',
            desc: 'Leads are instantly pushed to your CRM the moment a form is submitted.'
        },
        {
            icon: <FaShieldAlt />,
            title: 'Secure & Encrypted',
            desc: 'Each token is encrypted to ensure secure communication between your website and CRM.'
        },
        {
            icon: <FaChartLine />,
            title: 'Actionable Analytics',
            desc: 'Track form performance, submission sources, and customer behavior in real time.'
        },
        {
            icon: <FaPuzzlePiece />,
            title: 'Customizable Integration',
            desc: 'Works with any website – plain HTML, WordPress, React, or any other stack.'
        },
        {
            icon: <FaCode />,
            title: 'Zero Code Setup',
            desc: 'Just paste a single token into your form. We handle the rest automatically.'
        }
    ]

    return (
        <section className={styles.uspsSection}>
            <div className={styles.container}>
                <motion.h2
                    className={styles.heading}
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                    viewport={{ once: true }}
                >
                    Why Teams Love <span className={styles.highlight}>LeadBridge™</span>
                </motion.h2>

                <div className={styles.uspsGrid}>
                    {usps?.map((usp, index) => (
                        <motion.div
                            key={index}
                            className={styles.uspCard}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: index * 0.15 }}
                            viewport={{ once: true }}
                        >
                            <div className={styles.icon}>{usp.icon}</div>
                            <h3>{usp.title}</h3>
                            <p>{usp.desc}</p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default LbUsps
